import { render, staticRenderFns } from "./resources-view.vue?vue&type=template&id=5a7d62d0&scoped=true"
import script from "./resources-view.vue?vue&type=script&lang=js"
export * from "./resources-view.vue?vue&type=script&lang=js"
import style0 from "./resources-view.vue?vue&type=style&index=0&id=5a7d62d0&prod&lang=scss&scoped=true"
import style1 from "./resources-view.vue?vue&type=style&index=1&id=5a7d62d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d62d0",
  null
  
)

export default component.exports